module.exports = __webpack_public_path__ + "fba96e276b3dfd02f0cf7d8e5c749b0f.svg";